
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { InitialForm } from "@/components/initial-form/InitialForm";

interface HeroSectionProps {
  isSubmitting: boolean;
  onSubmit: (formData: { name: string; email: string; industry: string }) => Promise<void>;
  onScrollToForm: () => void;
}

export const HeroSection = ({ isSubmitting, onSubmit, onScrollToForm }: HeroSectionProps) => {
  return (
    <main className="w-full max-w-lg space-y-8 text-center">
      <img src="/lovable-uploads/9e6e6ba5-431d-43db-b089-cc6b969b71ce.png" alt="Client Keeper" className="w-64 mx-auto mb-4 pt-12" />
      <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl my-[60px] bg-gradient-to-r from-teal-600 via-cyan-500 to-blue-500 bg-clip-text text-transparent">Keep Your Best Clients Close—
No Velcro Required.</h1>

      <div id="signup-form" className="rounded-lg p-6 border bg-white/80 shadow-lg">
        <p className="text-gray-700 mb-6 font-semibold">Keep your best clients close with effortless, hyper-personalized messages—so you stay top-of-mind without the busywork of a CRM. </p>
        <InitialForm isSubmitting={isSubmitting} onSubmit={onSubmit} />
      </div>
      
      <p className="text-gray-600 text-lg font-bold">Not a CRM. Not another sales tool. Just effortless, personal client connection—done for you.</p>

      <div className="space-y-4 mt-8">
        <h2 className="text-3xl font-bold text-teal-700">Ready to Transform Client Connections?</h2>
        <p className="text-gray-600 text-lg">Start building stronger relationships and winning more referrals today.</p>
        <Button onClick={onScrollToForm} className="w-full bg-gradient-to-r from-teal-500 to-cyan-500 text-white hover:from-teal-600 hover:to-cyan-600 shadow-lg hover:shadow-xl transition-all duration-200">
          Start for Free
        </Button>
      </div>
    </main>
  );
};
